// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"673527e2","265":"a645329e","328":"0bee1b83","379":"a83fa180","605":"598ae60f","917":"bac07970","934":"d59c7430","943":"658fb6c4"}[chunkId] + ".chunk.js";
};